export default function PHP_ftp_close() {
  return (
    <div>
      <h1>PHP_ftp_close</h1>
    </div>
  );
}
